import * as Yup from 'yup'

const Document = Yup.object().shape({
  name: Yup.string().required('É obrigatório ao menos um arquivo.'),
})

export default Document
